import SegmentImpression, { ImpressionType } from './segment-impression';

export default SegmentImpression;
export { ImpressionType };
